var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * SUI kit can deal only with T: string (for option.value / value) on mobile view
 * So normalization is required
 * Since upcoming migration to modern UI kit is expected, that fix represented
 * as separate Wrapper what will be clearly remove later
 */
import React, { useCallback, useMemo } from 'react';
import { BaseSelect } from './BaseSelect';
export function NormalizedSelect(props) {
    var value = props.value, options = props.options, onChange = props.onChange, onBlur = props.onBlur;
    var normalizedOptions = useMemo(function () {
        return options.map(function (option) {
            var normalizedOption = __assign({}, option);
            normalizedOption.value = String(option.value);
            return normalizedOption;
        });
    }, [options]);
    var normalizedValue = useMemo(function () { return String(value); }, [value]);
    var getOriginalValue = useCallback(function (nextNormalizedValue) {
        var selectedOption = options.find(function (option) { return nextNormalizedValue === String(option.value); });
        return selectedOption.value;
    }, [options]);
    var handleChange = useCallback(function (value, e) {
        onChange && onChange(getOriginalValue(value), e);
    }, [getOriginalValue]);
    var handleBlur = useCallback(function (value, e) {
        onBlur && onBlur(getOriginalValue(value), e);
    }, [getOriginalValue]);
    return (React.createElement(BaseSelect, __assign({}, props, { value: normalizedValue, options: normalizedOptions, onChange: handleChange, onBlur: handleBlur })));
}
